import * as React from "react";
const SvgFiRrTipCoin = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tip-coin_svg__a)">
      <path
        fill="#062147"
        d="M8 22H5c-1.654 0-3-1.346-3-3v-4c0-1.654 1.346-3 3-3h5c1.081 0 2.083.586 2.615 1.528a.999.999 0 1 0 1.742-.982 5 5 0 0 0-1.359-1.54l.001-.006V8c0-.772-.445-1.437-1.088-1.77a3.4 3.4 0 0 0 .088-.73c0-1.93-1.57-3.5-3.5-3.5s-3.5 1.57-3.5 3.5c0 .169.017.335.041.5H3.999c-1.103 0-2 .897-2 2v3c0 .008.004.014.004.022C.793 11.935-.001 13.371-.001 15v4c0 2.757 2.243 5 5 5h3a1 1 0 1 0 0-2zM7 5.5C7 4.673 7.673 4 8.5 4s1.5.673 1.5 1.5c0 .188-.037.356-.09.5H7.09A1.4 1.4 0 0 1 7 5.5M4 10V8h7v2zM16.5 0C14.57 0 13 1.57 13 3.5S14.57 7 16.5 7 20 5.43 20 3.5 18.43 0 16.5 0m0 5c-.827 0-1.5-.673-1.5-1.5S15.673 2 16.5 2s1.5.673 1.5 1.5S17.327 5 16.5 5m1.1 11.8v6.4a.8.8 0 1 1-1.6 0v-6.4a.8.8 0 1 1 1.6 0m-2.5 0a.8.8 0 0 1-.8.8h-1.5v5.612a.8.8 0 0 1-1.6 0V17.6H9.8a.8.8 0 1 1 0-1.6h4.5a.8.8 0 0 1 .8.8m6.4-.8h-1.7a.8.8 0 0 0-.8.8v6.4a.8.8 0 1 0 1.6 0V21h.9a2.5 2.5 0 1 0 0-5m0 3.4h-.9v-1.801h.9a.9.9 0 0 1 0 1.801"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tip-coin_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrTipCoin;
